import $ from 'jquery';

const $html = $('html');
const $menu = $('.js-menu');
const $menuToggle = $('.js-menu-toggle');

$menuToggle.on('click', () => {
  $html.toggleClass('has-toggled-menu');
  $menu.toggleClass('is-toggled');
  $menuToggle.toggleClass('is-toggled');
});
